import React from 'react';
import { BookX, HelpCircle, Clock } from 'lucide-react';

const ProblemSection = ({ isDarkMode }) => {
  const problems = [
    {
      icon: BookX,
      title: 'Public Processes Are Illegible',
      description: 'Many government processes are convoluted and complex, requiring citizens to understand intense legal jargon that makes it incredibly difficult for the average person to read through.'
    },
    {
      icon: HelpCircle,
      title: 'Voter Awareness is Low',
      description: 'While congressional campaigns receive significant media coverage, state and local level politicians and their work receive far less attention, making it extremely difficult to keep track of who represents you and what they\'re doing.'
    },
    {
      icon: Clock,
      title: 'Civic Engagement is Expensive',
      description: 'It can take hours to comb through legislation, documentation, processes, and compare information across multiple platforms. Time, energy, and resources most people simply don\'t have.'
    }
  ];

  return (
    <section className="bg-[#ef4444] py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Politics Are Confusing
          </h2>
        <p className="text-xl md:text-2xl text-white">
          Staying informed About Government Requires Serious Effort.
        </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {problems.map((problem, index) => {
            const Icon = problem.icon;
            return (
              <div
                key={index}
                className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl flex flex-col h-full`}
              >
                {/* Top section */}
                <div className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-6 pb-4 flex-shrink-0`}>
                  <div className="flex flex-col items-center">
                    <div className={`w-16 h-16 rounded-full ${isDarkMode ? 'bg-red-900/30 border-2 border-red-800' : 'bg-red-50 border-2 border-red-200'} flex items-center justify-center mb-4`}>
                      <Icon className="w-8 h-8 text-[#ef4444]" />
                    </div>
                    <h3 className={`text-xl font-bold ${isDarkMode ? 'text-gray-100' : 'text-gray-900'} text-center`}>
                      {problem.title}
                    </h3>
                  </div>
                </div>
                
                {/* Bottom section */}
                <div className={`${isDarkMode ? 'bg-gray-700' : 'bg-gray-50'} p-6 pt-4 flex-grow flex items-center`}>
                  <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-center leading-relaxed`}>
                    {problem.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
